import { render } from "./ThreadedComments.vue?vue&type=template&id=2bc30092&scoped=true"
import script from "./ThreadedComments.vue?vue&type=script&lang=js"
export * from "./ThreadedComments.vue?vue&type=script&lang=js"

import "./ThreadedComments.vue?vue&type=style&index=0&id=2bc30092&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc30092"]])

export default __exports__